import * as React from 'react';

import classNames from 'classnames';

import { Button, VisuallyHidden } from '@coursera/cds-core';
import { SpinnerIcon } from '@coursera/cds-icons';

import { useEnrollInS12nSubscription } from 'bundles/enroll-common/utils/useEnrollInS12nSubscription';
import Icon from 'bundles/iconfont/Icon';
import TrackedButton from 'bundles/page/components/TrackedButton';
import { getTrackingData } from 'bundles/promotions/utils/productDiscountPromoUtils';

import _t from 'i18n!nls/enroll';

import 'css!./__styles__/SubscriptionEnrollButton';

type Props = {
  isFromS12nSelection: boolean;
  showCds?: boolean;
  onClick: () => void;
  enrolling: boolean;
};

const S12nSubscriptionEnrollButton = ({ isFromS12nSelection, showCds = false, onClick, enrolling }: Props) => {
  const { canEnrollThroughS12nSubscriptionFreeTrial: isFreeTrial } = useEnrollInS12nSubscription(isFromS12nSelection);

  const renderButtonContent = () => {
    if (enrolling && !showCds) {
      return '';
    } else {
      return isFreeTrial ? _t('Start Free Trial') : _t('Subscribe');
    }
  };

  const trackingName = isFreeTrial ? 'free_trial_start_button' : 'enroll_subscribe_monthly';

  const buttonClassName = !showCds
    ? classNames('subscribe-button', {
        'primary cozy': !enrolling,
      })
    : undefined;

  const getButtonIcon = () => {
    if (enrolling) {
      return showCds ? <SpinnerIcon /> : <Icon name="spinner" spin />;
    }
    return undefined;
  };

  return (
    <div className="rc-SubscriptionEnrollButton" role="status" aria-live="polite">
      <Button
        component={TrackedButton}
        data-e2e="subscription_enroll_button"
        trackingName={trackingName}
        data={getTrackingData()}
        className={buttonClassName}
        onClick={onClick}
        disabled={enrolling}
        withVisibilityTracking={false}
        requireFullyVisible={false}
        icon={getButtonIcon()}
        variant={showCds ? 'primary' : undefined}
      >
        {renderButtonContent()}
        {enrolling && (
          <VisuallyHidden component="span" className="rc-A11yScreenReaderOnly">
            {_t('Loading')}
          </VisuallyHidden>
        )}
      </Button>
    </div>
  );
};

export default S12nSubscriptionEnrollButton;
